import { fetcher } from '@commenda/utils';

interface RequestDetails {
  corporationId: number;

  complianceType: string;

  // Some compliances can be generated without a due date
  dueDate: string;

  effectiveStartDate?: string;
  effectiveEndDate?: string;
  fiscalYear: number;

  // If you need to assign a CA while creating the compliance
  caFirmId?: string;
}

export async function createComplianceItem(
  data: RequestDetails
): Promise<boolean> {
  const res = await fetcher('compliance', {
    method: 'POST',
    body: data,
  });

  return res.ok;
}
